import { useOutletContext } from 'react-router-dom';

export const useGoldenPageLayoutContext = () => {
  const result = useOutletContext<{ setTitle: (title: string) => void }>();

  return result;
};
